// extracted by mini-css-extract-plugin
module.exports = {"EmptyResults":"EmptyResults_EmptyResults__2gUUM","IconWrapper":"EmptyResults_IconWrapper__1E9kX","backLink":"EmptyResults_backLink__3ZpVH"};